import JsonLd from "@/components/JsonLd.tsx";
import JsonLdBreadcrumbList from "@/components/JsonLdBreadcrumbList.tsx";
import {createFileRoute} from '@tanstack/react-router'
import AboutPage from "../landing/AboutPage.tsx";

export const Route = createFileRoute('/about')({
    component: About,
})

function About() {
    return <>
        <JsonLd id={`page${Route.id}/about`} item={{
            "@context":    "https://schema.org",
            "@type":       "AboutPage",
            "name":        "About ScorePal",
            "description": "Learn more about ScorePal, a modern sports technology platform designed to simplify tournament management, live scoring, and player tracking for clubs and organizers. Proven performance over the past 2 years.",
            "url":         "https://scorepal.co/about/",
            "mainEntity":  {
                "@type":       "Organization",
                "name":        "ScorePal",
                "url":         "https://scorepal.co",
                "logo":        "https://scorepal.co/logo.png",
                "foundingDate": "2024",
                "description": "All-in-one sports management software for running leagues, tournaments, live scoring and rankings across racquet sports, team sports and esports.",
                "sameAs":      [
                    "https://www.instagram.com/scorepal_hq/",
                    "https://www.facebook.com/profile.php?id=61575217685230",
                    "https://apps.apple.com/us/app/score-pal/id6745509167",
                    "https://play.google.com/store/apps/details?id=co.scorepal.mobile"
                ]
            }
        }}></JsonLd>
        <JsonLdBreadcrumbList routeId={Route.id} crumbs={[{name: "About", item: "https://scorepal.co/about/"}]} />
        <AboutPage />
    </>
}
